import * as React from 'react'

import { List, Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import overlapPeriods from 'modules/work_schedules/store/collections/overlapPeriods'

import BlankSlate from './BlankSlate'
import Item from './Item'

const PeriodSection = ({ id }: { id: number }) => {
  const periods = overlapPeriods.getNonDefaultPeriods(id)
  const { navigation } = useNavigation()

  return (
    <Section.TwoThirds
      illustration="browser-edit"
      title={i18n.t('settings.work_schedule.period_section.title')}
      description={i18n.t('settings.work_schedule.period_section.description')}
      action={{
        label: i18n.t('settings.work_schedule.period_section.add'),
        to: navigation.settings.workSchedule.id.periodNew.fullPath({ id: id }),
      }}
    >
      <List>
        {!periods.length ? (
          <BlankSlate />
        ) : (
          periods.map((period, idx) => (
            <List.Item key={period.attributes.id}>
              <Item
                itemName={`${i18n.t('settings.work_schedule.period_section.period')} ${idx + 1}`}
                period={period}
              />
            </List.Item>
          ))
        )}
      </List>
    </Section.TwoThirds>
  )
}

export default observer(PeriodSection)
